import { useEffect } from "react";

export const useBrowserEffect =
  typeof window !== "undefined" ? useEffect : () => {};
